export default __webpack_public_path__ + "static/media/transfer_top.a6d6a798.jpg";